import magnifiAPIInstance from "./apiInstance";

export const teamAPIs = {
  getTeamByIds: ({ payload }) => magnifiAPIInstance.post(`/get/team_by_ids`, payload),
  getTeams: ({ payload }) => magnifiAPIInstance.post(`/teams`, payload),
  getAllTeams: ({ payload }) => magnifiAPIInstance.post(`/teams/all`, payload),
  getTournamentTeams: ({ tournamentId }) => magnifiAPIInstance.get(`/api/v3/tournament/${tournamentId}/teams`),
  uploadBulkTeamTournament: ({ payload }) => magnifiAPIInstance.post(`/api/v3/bulk-upload/teams-tournaments`, payload),
  createTeam: ({ payload }) => magnifiAPIInstance.post(`/team/create`, payload),
  updateTeam: ({ payload }) => magnifiAPIInstance.post(`/team/update`, payload),
  deleteTeam: ({ payload }) => magnifiAPIInstance.post(`/team/delete`, payload),
  validateAddTeamThroughCsv: ({ payload }) => magnifiAPIInstance.post(`/team/validate/csv`, payload),
  createBulkTeams: ({ payload }) => magnifiAPIInstance.post(`/team/create/many`, payload),
};
